// src/components/AreaCard.jsx
// src/components/AreaCard.jsx
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../styles/AreaCard.css';

const AreaCard = ({ title, summary, details, icon, bg, bgAlt, bgPosition }) => {
  const [expanded, setExpanded] = useState(false);
  const toggle = () => setExpanded(e => !e);

  const hasBg = Boolean(bg);
  const items = Array.isArray(details) ? details : (details ? [details] : []);

  return (
    <div
      className={`area-card ${expanded ? 'expanded' : ''} ${hasBg ? 'has-bg' : ''}`}
      onClick={toggle}
      onMouseEnter={() => setExpanded(true)}
      onMouseLeave={() => setExpanded(false)}
    >
      {hasBg && (
        <>
          <img
            className="area-card__bg"
            src={bg}
            alt={bgAlt || ''}
            aria-hidden={bgAlt ? undefined : true}
            loading="lazy"
            decoding="async"
            style={{ objectPosition: bgPosition }}
          />
          <div className="area-card__scrim" />
        </>
      )}

      <div className="area-card__content">
        <div className="icon">{icon}</div>
        <h3>{title}</h3>
        <p className="summary">{summary}</p>

        {expanded && items.length > 0 && (
          <ul className="details-list">
            {items.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

AreaCard.propTypes = {
  title: PropTypes.string.isRequired,
  summary: PropTypes.string.isRequired,
  details: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  icon: PropTypes.node,
  // Nuevos props
  bg: PropTypes.string,        // URL o import de imagen
  bgAlt: PropTypes.string,     // Texto alternativo (opcional)
  bgPosition: PropTypes.string // p.ej. 'center top', '50% 30%', etc.
};

AreaCard.defaultProps = {
  details: '',
  icon: '',
  bg: '',
  bgAlt: '',
  bgPosition: 'center'
};

export default AreaCard;
